import React, { useRef } from 'react';
import {useState, useContext, useEffect} from 'react';
import Calendar from 'react-calendar/dist/umd/Calendar';
import { Popover, PopoverBody, Button, Spinner, Row, Table, Modal, ModalHeader, ModalBody, Input, FormGroup, InputGroup, InputGroupAddon, Card, CardHeader, CardBody } from 'reactstrap';
import { AppContext } from './AppContext';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Tabla } from './Tabla';
import { Pacientes } from './Pacientes';
import {Buscador, BuscadorArticulos} from './Buscador';
import { Panel } from './Panel';

export const Citas = () => {
    const edoGlobal = useContext(AppContext);
    let [almacen, setAlmacen] = useState(2);
    let [modalPac,setModalPac] = useState(false);
    let [fecha,setFecha] = useState(new Date());
    let [citas,setCitas] = useState([]);
    let [tiposPac,setTiposPac] = useState([]);
    let [estadosPac,setEstadosPac] = useState([]);
    let [idCita,setIdCita] = useState(0);
    let [deptos,setDeptos] = useState([]);
    let [horas,setHoras] = useState([]);
    let [depto, setDepto] = useState(0);
    let [avisos,setAvisos] = useState("");
    let [descrip,setDescrip] = useState("");
    let [pacientes,setPacientes] = useState([]);
    let [cargando,setCargando] = useState(false);
    let [editando,setEditando] = useState(false);
    let [selPac,setSelPac] = useState(false);
    let [todo,setTodo] = useState(true);
    let [hora,setHora] = useState("");
    let [paciente,setPaciente] = useState({});
    let [tipoPac, setTipoPac] = useState(-1);
    let [edoPac, setEdoPac] = useState(0);
    let [nomTipoPac,setNomTipoPac] = useState("");
    let [idCte, setIdCte] = useState(0);
    let [idPac, setIdPac] = useState(0);
    let [orden,setOrden] = useState("");
    let [tipo,setTipo] = useState("P");
    let [texto,setTexto] = useState("");
    let [nombreCte, setNombreCte] = useState("PUBLICO EN GENERAL");
    let [nombrePac,setNombrePac] = useState("");
    let [nomMed,setNomMed] = useState("");
    let [regImss,setRegImss] = useState("");
    let [clinica,setClinica] = useState("");
    let [fechaCitaImss,setFechaCitaImss] = useState("");
    let [conSedacion,setConSedacion] = useState(false);
    let [codigo, setCodigo] = useState("");
    let [nombreEst,setNombreEst] = useState("");
    let [nombre,setNombre] = useState("");
    let [apePat,setApePat] = useState("");
    let [apeMat,setApeMat] = useState("");
    let [popoverArtiOpen,setPopoverArtiOpen] = useState(false);
    let [popoverMedOpen,setPopoverMedOpen] = useState(false);
    let [popoverCteOpen,setPopoverCteOpen] = useState(false);
    let [medico, setMedico] = useState({});
    let [idMed, setIdMed] = useState(0);
    let [nombreMed, setNombreMed] = useState("");
    let [citaMov, setCitaMov] = useState(null);
    let [fechaMov, setFechaMov] = useState("");
    let [empresa,setEmpresa] = useState(0);
    let [lista, setLista] = useState("A");
    let [cliente, setCliente] = useState({});
    let [articulo, setArticulo] = useState({Codigo:'',Descripcion:'',DescripcionSedacion:''});
    let [cambios, setCambios] = useState(false);
    let [disponible, setDisponible] = useState("");
    let minutosDisponibles = useRef(0);

    useEffect(() => {
        (async () => {
            empresa = 2;  //edoGlobal.usuario.Empresa;
            setEmpresa(2);//edoGlobal.usuario.Empresa);
            cargarDeptos();
        })();
    }, []);

    useEffect(() => {
        (async () => {
            cargarCitas(horas);
        })();
    }, [fecha]);

    useEffect(() => {
        (async () => {
            cargarHoras();
        })();
    }, [depto]);

    function cambiarSedacion(valor){
        setConSedacion(valor);
        if(valor && articulo.DescripcionSedacion != '')
            setDescrip(articulo.DescripcionSedacion);
        if(!valor && articulo.Descripcion != '')
            setDescrip(articulo.Descripcion);
    }
    async function cargarDeptos(){
        setCargando(true);
        let url = `${edoGlobal.urlws}/home/departamentos/${empresa}`;
        let resp = await fetch(url);
        let dep = await resp.json();

        url = `${edoGlobal.urlws}/factura/tiposPaciente/${empresa}`;
        resp = await fetch(url);
        const tp = await resp.json();

        url = `${edoGlobal.urlws}/home/estadosPaciente/`;
        resp = await fetch(url);
        const ep = await resp.json();

        setCargando(false);
        setDeptos(dep);
        setTiposPac(tp);
        setEstadosPac(ep);

        if(dep.length != 0){
           depto = dep[0].I;
           setDepto(depto);
        }
    }

    async function cargarHoras(){
        setCargando(true);
        let url = `${edoGlobal.urlws}/home/citasHorario/${empresa}?dep=${depto}`;
        let resp = await fetch(url);
        const hr = await resp.json();
        setHoras(hr);
        setCargando(false);
        cargarCitas(hr);
        setCambios(!cambios);
    }
    function limpiar(hrs){
        for(let h = 0; h < hrs.length; h++){
            hrs[h].I = 0;
            hrs[h].N = "";
            hrs[h].E = "";
            hrs[h].TipoPac = -1;
            hrs[h].EstadoPac = 0;
            hrs[h].NomTipoPac = "";
            hrs[h].NomEdoPac = "";
            hrs[h].T = "";
            hrs[h].R = "";
            hrs[h].ConSedacion = "";
            hrs[h].Clinica = "";
            hrs[h].FechaCitaImss = "";
            hrs[h].NomMed = "";
            hrs[h].RegImss = "";
            hrs[h].OrdenPac = 0;
        }
    }
    async function cargarCitas(hrs){
        setCargando(true);
        let ordenPac = 1;
        let alm = almacen;
        let fec = fecha.yyyymmdd('-');
        let hr = "";
        let url = `${edoGlobal.urlws}/home/citasDepto/${empresa}?alm=${alm}&fecha=${fec}&depto=${depto}`;
        let resp = await fetch(url);
        const data = await resp.json();
        limpiar(hrs);
        let tiempo = 0;
        let ponerDatosPac = true;
        for(let c = 0; c < data.length; c++){
            hr = data[c].H;
            tiempo = data[c].Tiempo;
            ponerDatosPac = true;
            for(let h = 0; h < hrs.length; h++){
                if(hr == hrs[h].H){
                    do{
                        try{
                            asignar(hrs, h, c, ordenPac, ponerDatosPac, data);
                        }catch(e){

                        }
                        //ponerDatosPac = false;
                        tiempo -= 10;
                        h++;
                    }while(tiempo > 0 && h < hrs.length);
                    ordenPac++;
                }
            }
        }
        setEditando(false);
        setCitas(data);
        setCargando(false);
        setCambios(!cambios);
    }
    function asignar(hrs, h, c, ordenPac, ponerDatosPac, data) {
        hrs[h].I = data[c].I;
        if(ponerDatosPac){
            hrs[h].N = data[c].P;
            hrs[h].E = data[c].E;
            hrs[h].NomTipoPac = data[c].T;
            hrs[h].NomEdoPac = data[c].NombreEstadoPac;
        }
        hrs[h].TipoPac = data[c].Tipo;
        hrs[h].EstadoPac = data[c].EstadoPac;
        hrs[h].M = data[c].M;
        hrs[h].R = data[c].R;
        hrs[h].Cod = data[c].Cod;
        hrs[h].Pac = data[c].Pac;
        hrs[h].Med = data[c].Med;
        hrs[h].T = data[c].Txt;
        hrs[h].ConSedacion = data[c].ConSedacion;
        hrs[h].FechaCitaImss = data[c].FechaCitaImss;
        hrs[h].Clinica = data[c].Clinica;
        hrs[h].NomMed = data[c].NomMed;
        hrs[h].RegImss = data[c].RegImss;
        hrs[h].OrdenPac = ordenPac;
    }
    function colorFondo(orden){
        if(orden == 0)
            return 'transparent';
        if(orden % 2 == 0)
            return 'silver';
        return 'gray';
    }
    function pacSeleccionado(dato){
        setPaciente(dato);
        setIdPac(dato.Id);
        setRegImss(dato.RegImss);
        setNombrePac(dato.Nombre + " " + dato.ApePat + " " + dato.ApeMat);
        setModalPac(false);
    }
    function articuloSel(a){
        codigo = a.C;
        cargarArticulo();
    }
    function clienteSel(c){
        idCte = c.C;
        cargarCliente();       
    }
    async function cargarCliente() {
        setCargando(true);
        let url = `${edoGlobal.urlws}/cliente/carga/${idCte}?db=${empresa}`;
        let resp = await fetch(url);
        const dato = await resp.json();
        setCargando(false);
        if(dato.Empresa == 0){
            setNombreCte("No registrado");
            return;
        }
        lista = dato.ListaDMA;
        setCliente(dato);
        setIdCte(idCte);
        setLista(dato.ListaDMA);
        setNombreCte(dato.Nombre);
        setTexto(dato.Comentario);
        setAvisos(dato.Avisos);
        if(dato.EsIMSS){
            setClinica(dato.NombreComercial);
        }
    }
    async function cargarMedico() {
        setCargando(true);
        let url = `${edoGlobal.urlws}/medico/cargar/${idMed}?db=${empresa}`;
        let resp = await fetch(url);
        const dato = await resp.json();
        setCargando(false);
        if(dato.Clave == 0){
            setNombreMed("No registrado");
            return;
        }
        setMedico(dato);
        setIdMed(idMed);
        setNombreMed(dato.NombreCompleto);
    }
    function medicoSel(c){
        idMed = c.I;
        cargarMedico();       
    }
    async function cargarArticulo() {
        setCargando(true);
        let url = `${edoGlobal.urlws}/articulo/cargarPrecio/${codigo}?db=${empresa}&alm=${almacen}&lista=${lista}&medico=${idMed}&cliente=${idCte}`;
        let resp = await fetch(url);
        const dato = await resp.json();
        setCargando(false);
        if(dato.Empresa == 0){
            setNombreEst("No registrado");
            return;
        }
        if(dato.Depto != depto){
            Swal.fire('Atencion','Este estudio es de otro departamento','error');
            return;
        }
        if(minutosDisponibles.current > 0 && dato.Tiempo > minutosDisponibles.current){
            Swal.fire('Atencion','Este estudio ocupa ' + dato.Tiempo + " minutos",'error');
            return;
        }
        if(dato.PDescto > 0)
           dato.Precio = dato.Precio - Math.round(dato.Precio * dato.PDescto / 100,0);
        Swal.fire(dato.Codigo,dato.Nombre + " // Precio: " + dato.Precio,'info');
        setArticulo(dato);
        setCodigo(codigo);
        setNombreEst(dato.Nombre + " // Precio: " + dato.Precio);
        if(conSedacion)
            setDescrip(dato.DescripcionSedacion);
        else
            setDescrip(dato.Descripcion);
    }
    async function cargarPaciente() {
        setCargando(true);
        let url = `${edoGlobal.urlws}/paciente/cargar/${idPac}?db=${empresa}`;
        let resp = await fetch(url);
        const dato = await resp.json();
        setCargando(false);
        if(dato.Id == 0){
            setNombrePac("No registrado");
            return;
        }
        setPaciente(dato);
        setIdPac(idPac);
        setNombrePac(dato.Nombre + " " + dato.ApePat + " " + dato.ApeMat);
    }
    async function cargarPacientes(){
        if (nombre + apePat + apeMat === "")
            return;
        setCargando(true);
        let url = `${edoGlobal.urlws}/paciente/lista?nutriologo=${edoGlobal.usuario.Id}&apePat=${apePat}&apeMat=${apeMat}&nombre=${nombre}`;
        let resp = await fetch(url);
        const pacientes = await resp.json();
        setCargando(false);
        setPacientes(pacientes);
    }

    /*
    function seleccionar(i){
        const nom = pacientes[i].N + ' ' + pacientes[i].P + ' ' + pacientes[i].M;
        const MySwal = withReactContent(Swal)
        setSelPac(false);
        MySwal.fire({
            title: 'Confirme',
            text: "¿ agendar a " + nom + " a las " + hora + " ?",
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
          }).then((result) => {
            if (result.value) {
                grabaCita(i);
            }
          })        
    }
    */
    async function guardar(){
        if(tipoPac < 0){
            Swal.fire('Atencion','No se ha indicado el tipo de paciente','error');
            return;
        }
        if(cliente.EsIMSS){
            if(regImss == ""){
                Swal.fire('Atencion','No se ha indicado el No. de registro IMSS','error');
                return;
            }
            if(clinica == ""){
                Swal.fire('Atencion','No se ha indicado la clinica IMSS','error');
                return;
            }
            if(fechaCitaImss == ""){
                Swal.fire('Atencion','No se ha indicado la fecha de cita en el IMSS','error');
                return;
            }
            if(idMed < 2){
                Swal.fire('Atencion','No se ha indicado el medico IMSS','error');
                return;
            }
       }
        let momTipoPac = "";
        if(tipoPac == 4 || tipoPac == 5)
           nomTipoPac = tipoPac == 4 ? "IMSS":"ISSSTE" + " " + clinica;
        const dato = {
            Id : idCita, Almacen : almacen, //edoGlobal.usuario.Almacen,
            Empresa : empresa, Usuario : edoGlobal.usuario.Id,
            Fecha : fecha.yyyymmdd('-'),
            Depto : depto, Cliente: idCte, Paciente:idPac,
            Hora:hora, Codigo : codigo, Medico:idMed,
            Orden : orden, Tipo : tipo, Texto : texto,
            TipoPac : tipoPac, NomTipoPac : nomTipoPac, EstadoPac: edoPac,
            Clinica : clinica, NomMedico : nomMed, FechaCitaImss:fechaCitaImss,
            RegImss : regImss, ConSedacion : conSedacion ? "S":"N"
        }
        let url = `${edoGlobal.urlws}/home/wsguardarCita`;
        setCargando(true);
        const json = JSON.stringify(dato);
        const resp = await fetch(url,{
            method: 'POST', // or 'PUT'
            body: json // data can be `string` or {object}!
          });
        const res = await resp.text();
        setCargando(false);
        if(res === "ok"){
            setEditando(false);
            cargarCitas(horas)
        }
        else{
            Swal.fire('Atencion',res,'error');
            cargarCitas(horas)
        }
    }
    function nueva(i){
        let j = 0;
        let hrIni = horas[i].H;
        let hrFin = "";
        let espacios = 0;
        for(j = i; j < horas.length; j++ ){
            hrFin = horas[j].H;
            if(horas[j].I > 0)
                break;
            espacios++;
        }
        minutosDisponibles.current = espacios * 10;
        if(citaMov != null){
            reagendarCita(i);
            return;
        }
        setDisponible("Disponible de " + hrIni + ' a ' + hrFin + ' ' + minutosDisponibles.current + " minutos");
        setIdCita(0);
        setTipoPac(-1);
        setEdoPac(0);
        setAvisos("");
        setNomMed("");
        setClinica("");
        setFechaCitaImss("");
        setConSedacion(false);
        setRegImss("");
        setNomTipoPac("");
        setIdMed(0);
        setIdPac(0);
        setDescrip("");
        setCodigo("");
        setHora(horas[i].H);
        setNombrePac("");
        setNombreEst("");
        setNombreMed("");
        setTexto("");
        setEditando(true);
    }
    function reagendarCita(i){
        let tiempo = 0;
        for(let j = 0; j < citas.length; j++)
            if(citas[j].I == citaMov.I)
                tiempo = citas[j].Tiempo;
        if(minutosDisponibles.current > 0 && tiempo > minutosDisponibles.current){
            Swal.fire('Atencion','Este estudio ocupa ' + tiempo + " minutos",'error');
            return;
        }
        let hr = horas[i].H;
        const MySwal = withReactContent(Swal)
        MySwal.fire({
            title: 'Confirme',
            text: "¿ reagendar la cita de " + citaMov.P + " del " + fechaMov.yyyymmdd('-') + " a las " + citaMov.H + " al " + fecha.yyyymmdd('-') + " a las " + hr + " ?",
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
          }).then((result) => {
            if (result.value) {
                reagendarCitaB(hr);
            }
          })        
    }
    async function reagendarCitaB(hr){
        let url = `${edoGlobal.urlws}/home/moverCita/${citaMov.I}?db=${empresa}&fecha=${fecha.yyyymmdd('-')}&hora=${hr}`;
        const resp = await fetch(url,{ method: 'POST'});
        const res = await resp.text();
        if(res === "ok"){
            setCitaMov(null);
            cargarCitas(horas);
        }
        else
            Swal.fire('Atencion',res,'error');
    }

    function editar(i){
        codigo = horas[i].Cod;
        console.log(horas[i]);
        setIdCita(horas[i].I);
        setDescrip("");
        setIdMed(horas[i].Med);
        setIdPac(horas[i].Pac);
        setTipoPac(horas[i].TipoPac)
        setEdoPac(horas[i].EstadoPac)
        setCodigo(horas[i].Cod);
        setHora(horas[i].H);
        setNombrePac(horas[i].N);
        setNombreEst(horas[i].E);
        setNombreMed(horas[i].M);
        setTexto(horas[i].T);
        setNomMed(horas[i].NomMed);
        setClinica(horas[i].Clinica);
        setFechaCitaImss(horas[i].FechaCitaImss);
        cambiarSedacion(horas[i].ConSedacion == "S");
        setRegImss(horas[i].RegImss);
        setEditando(true);
        cargarArticulo();
        //setSelPac(true);
    }
    function imprimir(i){
        const url = `${edoGlobal.urlws}/home/citaPDF/${i}`;
        window.open(url, '', '');
    }

    function moverCita(i){
        setFechaMov(fecha);
        for(let c = 0; c < citas.length; c++)
           if(horas[i].I == citas[c].I){
              setCitaMov(citas[c]);
              break;
           }
    }
    function eliminar(i){
        const MySwal = withReactContent(Swal)
        MySwal.fire({
            title: 'Confirme',
            text: "¿ quitar la cita de " + horas[i].N + " ?",
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
          }).then((result) => {
            if (result.value) {
                eliminarB(horas[i].I);
            }
          })        
    }
    async function eliminarB(i){
        let url = `${edoGlobal.urlws}/home/eliminarCita/${i}?db=${empresa}`;
        const resp = await fetch(url,{ method: 'POST'});
        const res = await resp.text();
        if(res === "ok"){
            cargarCitas(horas);
        }
        else
            Swal.fire('Atencion',res,'error');
    }
    function cambiarTipoPac(tp){
        setTipoPac(tp);
        /*
        if(tp == 4 || tp == 5)
           capturarNomTipoPac(tp == 4 ? "IMSS":"ISSSTE");
        else
           setNomTipoPac("");
        */
    }
    async function capturarNomTipoPac(inst){
        const { value: clinica } = await Swal.fire({
            title: 'Numero de clinica',
            input: 'text',
            inputLabel: 'Numero de clinica',
            inputPlaceholder: ''
          })
          if (clinica)
             setNomTipoPac(inst + " " + clinica);
          else
             setNomTipoPac("");
    }
    async function cambiarEmpresa(e){
        empresa = e;
        await setEmpresa(e);
        await cargarDeptos();
        await cargarCitas(horas);
    }
    const estiloListado = { display: editando ? 'none' : 'inline' };
    const estiloCaptura = { display: !editando ? 'none' : 'inline' };
    return(
        <div>
            <Row>
                <div className='col-3'>
                    {edoGlobal.usuario.CallCenter && <div className="row">
                        <div className="col">
                            <div className="form-group" size="sm">
                                <span>Empresa</span>
                                <Input size="sm" type="select" className="form-control form-control-sm" name="emp" value={empresa} onChange={e => cambiarEmpresa(e.target.value)} >
                                    <option value={0}>Seleccione</option>
                                    <option value={2}>D.M.I.</option>
                                    <option value={1}>Analizate</option>
                                </Input>
                            </div>
                        </div>
                    </div>
                    }
                    <Calendar onChange={setFecha} value={fecha}/>

                    { citaMov != null &&
                    <div>
                        <br/>
                        <br/>
                            <Card>
                                <CardHeader>
                                    <h6>Reagendando cita</h6>
                                </CardHeader>
                                <CardBody>
                                    <span>{fechaMov.yyyymmdd('-')}</span><br />
                                    <span>{citaMov.H}</span><br />
                                    <span>{citaMov.P}</span><br />
                                    <span>{citaMov.E}</span><br />
                                    <span>{citaMov.Txt}</span><br />
                                    <br />
                                    <Button size="sm" color="danger" onClick={() => setCitaMov(null)} >Cancelar</Button>
                                </CardBody>
                            </Card>
                    </div>
                    }
                                        <br/>
                    <b>Concentrado  - Citas : {citas.length}</b>
                    <Table size="sm" striped>
                        <tbody>
                            {citas.map((o, i) => <tr key={i}>
                                <td>{o.H}</td>
                                <td>{o.P}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </div>
                <div className='col'>
                    <table>
                        <tr>
                            <td>
                               <h4>{fecha.yyyymmdd('-')}</h4>
                            </td>
                            <td>
                                <Input size="sm" type="select" value={depto} onChange={e => setDepto(e.target.value)}>
                                    <option value={-1}>Especifique</option>
                                    {deptos.map((o,i)=><option key={i} value={o.I}>{o.N}</option>)}
                                </Input>
                            </td>
                            <td><Button outline size="sm" color="success"><img src="/imagenes/ok.png" title="actualizar" /></Button></td>
                            <td>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                            </td>
                            <td>
                                <input type="checkbox" checked={todo} onChange={(e) => setTodo(e.target.checked)} />
                            </td>
                            <td>
                                Ver horario completo
                            </td>
                        </tr>
                    </table>
                    <div style={estiloListado}>
                        <Table size="sm" striped hover>
                            <thead>
                                <tr>
                                    <th className='numeroCeldaCh'>Hora</th>
                                    <th className='celdaNombre'>Paciente</th>
                                    <th className='celdaMed'>Tipo</th>
                                    <th className='celdaMed'>Estado</th>
                                    <th>Estudio</th>
                                    <th style={{ width: '30px' }}></th>
                                    <th style={{ width: '30px' }}></th>
                                    <th style={{ width: '30px' }}></th>
                                    <th>Tiket</th>
                                </tr>
                            </thead>
                            <tbody>
                                {horas.filter(h => todo || h.I > 0).map((o, i) =>
                                    <tr key={i} style={{background:colorFondo(o.OrdenPac)}}>
                                        <td>{o.H}</td>
                                        {o.ConSedacion != "S" ?
                                        <td>{o.N}</td>
                                        :
                                        <td>{o.N} <b style={{color:'red'}}>CON SEDACION</b></td>
                                        }
                                        <td>{o.NomTipoPac}</td>
                                        <td>{o.NomEdoPac}</td>
                                        <td>{o.E}</td>
                                        <td>
                                            {o.R !== "" ? null :
                                            <div>
                                              {o.I === 0 && <img src="/imagenes/add.png" alt="nueva" title="nueva cita" onClick={() => nueva(i)} /> }
                                              {o.I > 0 && edoGlobal.usuario.CallCenter && <img src="/imagenes/edit.png" alt="editar" title="editar cita" onClick={() => editar(i)} />}
                                            </div>
                                            }
                                        </td>
                                        <td>
                                            {edoGlobal.usuario.CallCenter && o.I > 0 && <img onClick={() => eliminar(i)} src="/imagenes/menos.png" alt="eliminar" title="borrar cita" />}
                                        </td>
                                        <td>
                                            {o.I > 0 && <img onClick={() => imprimir(o.I)} src="/imagenes/printer.png" alt="imprimir cita" title="imprimir cita" />}
                                        </td>
                                        <td>
                                            {o.R !== "" || o.I === 0 ? o.R  : <img onClick={() => moverCita(i)} src="/imagenes/citas.png" alt="mover" title="mover cita" />}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    <div style={estiloCaptura}>
                        <Panel titulo={"Cita para las " + hora + "  " + disponible}>
                            <table >
                                <tr>
                                    <td ><b>Paciente</b></td>
                                    <td style={{ width: '100px' }}>
                                        <InputGroup>
                                            <Input size="sm" type="text" value={idPac} onChange={e => setIdPac(e.target.value)} onKeyPress={(e) => { if (e.which == 13) cargarPaciente(); }} />
                                            <InputGroupAddon addonType="append">
                                                &nbsp;
                                                <Button outline size="sm" color="secondary" onClick={() => setModalPac(true)}>
                                                    <img src="/imagenes/zoom.png" alt="buscar" title="buscar" />
                                                </Button>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </td>
                                    <td style={{ width: '700px' }}>
                                        <Input size="sm" value={nombrePac} />
                                    </td>
                                </tr>
                                <tr>
                                    <td ><b>Cliente</b></td>
                                    <td style={{ width: '100px' }}>
                                        <InputGroup>
                                            <Input size="sm" type="text" value={idCte} onChange={e => setIdCte(e.target.value)} onKeyPress={(e) => { if (e.which == 13) cargarCliente(); }} />
                                            <InputGroupAddon addonType="append">
                                            &nbsp;
                                            <Button size="sm" outline color="secondary" id="btnBuscarCteCita">
                                                <img src="/imagenes/zoom.png" alt="buscar" title="buscar" />
                                            </Button>
                                            <Popover trigger="legacy" placement="right" isOpen={popoverCteOpen} target="btnBuscarCteCita" toggle={() => setPopoverCteOpen(!popoverCteOpen)} >
                                                <PopoverBody>
                                                    <Buscador campoId="C" onSelect={clienteSel} url={edoGlobal.urlws + "/cliente/lista/" + empresa + "?filtro="} tema="ctes" />
                                                </PopoverBody>
                                            </Popover>
                                        </InputGroupAddon>
                                        </InputGroup>
                                    </td>
                                    <td style={{ width: '700px' }}>
                                        <Input size="sm" value={nombreCte} />
                                    </td>
                                </tr>
                            </table>
                            <table>
                                <tr>
                                    <td ><b>Codigo</b></td>
                                    <td style={{ width: '200px' }}>
                                        <InputGroup>
                                            <Input size="sm" type="text" value={codigo} onChange={e => setCodigo(e.target.value)} onKeyPress={(e) => { if (e.which == 13) cargarArticulo(); }} />
                                            <InputGroupAddon addonType="append">
                                                &nbsp;
                                                <Button outline size="sm" color="secondary" id="btnBuscarArtiC">
                                                    <img src="/imagenes/zoom.png" alt="buscar" title="buscar" />
                                                </Button>
                                                <Popover trigger="legacy" placement="right" isOpen={popoverArtiOpen} target="btnBuscarArtiC" toggle={() => setPopoverArtiOpen(!popoverArtiOpen)} >
                                                    <PopoverBody>
                                                        <BuscadorArticulos onSelect={articuloSel} url={edoGlobal.urlws + "/articulo/listadepto/" + empresa + "?depto=" + depto + "&filtro="} />
                                                    </PopoverBody>
                                                </Popover>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </td>
                                    <td style={{ width: '700px' }}>
                                        <Input size="sm" value={nombreEst} />
                                    </td>
                                </tr>
                            </table>
                            <table>
                                <tr>
                                    <td ><b>Medico</b></td>
                                    <td style={{ width: '100px' }}>
                                        <InputGroup>
                                            <Input size="sm" type="text" value={idMed} onChange={e => setIdMed(e.target.value)} onKeyPress={(e) => { if (e.which == 13) cargarMedico(); }} />
                                            <InputGroupAddon addonType="append">
                                                &nbsp;
                                                <Button outline size="sm" color="secondary" id="btnBuscarMedC">
                                                    <img src="/imagenes/zoom.png" alt="buscar" title="buscar" />
                                                </Button>
                                                <Popover trigger="legacy" placement="right" isOpen={popoverMedOpen} target="btnBuscarMedC" toggle={() => setPopoverMedOpen(!popoverMedOpen)} >
                                                    <PopoverBody>
                                                        <Buscador campoId="I" onSelect={medicoSel} url={edoGlobal.urlws + "/medico/lista/" + empresa + "?filtro="} tema="meds" />
                                                    </PopoverBody>
                                                </Popover>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </td>
                                    <td style={{ width: '700px' }}>
                                        <Input size="sm" value={nombreMed} />
                                    </td>
                                </tr>
                            </table>
                            <Row>
                                <div className='col-3'>
                                    <b>Reg.IMSS</b>
                                    <Input size="sm" type="text" value={regImss} onChange={e => setRegImss(e.target.value)} />
                                </div>
                                <div className='col-2'>
                                    <b>Tipo paciente</b>
                                    <Input size="sm" type="select" value={tipoPac} onChange={e => cambiarTipoPac(e.target.value)}>
                                                <option value={-1}>Especifique</option>
                                                {tiposPac.map((o, i) => <option key={i} value={o.I}>{o.N}</option>)}
                                    </Input>
                                    <span>{nomTipoPac}</span>
                                </div>
                                <div className='col-2'>
                                    <b>Estado paciente</b>
                                    <Input size="sm" type="select" value={edoPac} onChange={e => setEdoPac(e.target.value)}>
                                        {estadosPac.map((o, i) => <option key={i} value={o.Id}>{o.Nombre}</option>)}
                                    </Input>
                                    <span>{nomTipoPac}</span>
                                </div>
                                <div className='col-2'>
                                    <b>Clinica IMSS</b>
                                    <Input size="sm" type="text" value={clinica} onChange={e => setClinica(e.target.value)} />
                                </div>
                                <div className='col-2'>
                                    <b>Fecha cita en IMSS</b>
                                    <Input size="sm" type="text" value={fechaCitaImss} onChange={e => setFechaCitaImss(e.target.value)} />
                                </div>
                                <div className='col'>
                                    <b>Sedacion</b><br/>
                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><Input size="sm" type="checkbox" checked={conSedacion} onChange={e =>  cambiarSedacion(e.target.checked)} />
                                </div>
                            </Row>
                            <br/>
                            <Row>
                                <div className='col'>
                                    <b>Indicaciones</b><br />
                                    <Input rows="5" type="textarea" size="sm" value={descrip} />
                                    <br />
                                    <b>Avisos importantes</b><br />
                                    <Input rows="5" type="textarea" size="sm" value={avisos} />
                                    <br />
                                    <br />
                                    <Button size="sm" color="success" onClick={guardar}>guardar</Button>
                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                    <Button size="sm" color="danger" onClick={() => setEditando(false)}>Cancelar</Button>
                                </div>
                                <div className='col'>
                                    <b>Documentos requeridos</b>
                                    <Input rows="10"  type="textarea" size="sm" value={texto} onChange={e => setTexto(e.target.value)} />
                                </div>
                            </Row>
                        </Panel>
                    </div>
                </div>
            </Row>
            <Modal size="lg" isOpen={selPac} toggle={() => setSelPac(false)}>
                <ModalHeader>
                    <span>Indique el paciente para cita a las {hora}</span>
                </ModalHeader>
                <ModalBody>
                    <div>
                        <div className="row">
                            <div className="col-2">
                                <FormGroup  >
                                    <span>Apellido Paterno</span>
                                    <Input size="sm" type="text" value={apePat} onChange={e => setApePat(e.target.value)} />
                                </FormGroup>
                            </div>
                            <div className="col-2">
                                <FormGroup  >
                                    <span>Apellido Materno</span>
                                    <Input size="sm" type="text" value={apeMat} onChange={e => setApeMat(e.target.value)} />
                                </FormGroup>
                            </div>
                            <div className="col-2">
                                <FormGroup  >
                                    <span>Nombre</span>
                                    <Input size="sm" type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
                                </FormGroup>
                            </div>
                            <div className="col-1">
                                <br />
                                <Button outline color="success" size="sm" onClick={cargarPacientes}><img src="imagenes/zoom.png" alt="buscar" /></Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal size="lg" isOpen={modalPac} toggle={() => setModalPac(false)}>
                <ModalHeader></ModalHeader>
                <ModalBody>
                    <Pacientes sel={true} pacSeleccionado={pacSeleccionado} empresa={empresa}/>
                </ModalBody>
            </Modal>
            {cargando ? (
          <div className="loader">
            <Spinner animation="border" color="warning" />
          </div>
        ) : null}
        </div>
    );
}